import * as yup from 'yup';

export const IndividualCentralDataValidationSchema = yup.object().shape({
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
    gender: yup.number().required('Gender is required').typeError('Gender is required'),
    raceId: yup.number().required('Race is required').typeError('Race is required'),

    identificationNumber: yup.string().when('employeeCode', {
        is: (EmployeeCode: string) => !EmployeeCode || EmployeeCode.length === 0,
        then: yup.string().required("ID Number or Employee Code is required"),
        otherwise: yup.string().nullable()
    }),
    employeeCode: yup.string().when('identificationNumber', {
        is: (IdentificationNumber: string) => !IdentificationNumber || IdentificationNumber.length === 0,
        then: yup.string().required("ID Number or Employee Code is required"),
        otherwise: yup.string().nullable()
    })
}, [['employeeCode', 'identificationNumber']]
);